import * as Sentry from '@sentry/vue';
import axios, { AxiosError, AxiosResponse } from 'axios';

interface ErrorData {
   errors?: Record<string, unknown>;
   errorMessage?: string;
   message?: string;
}

function captureSentryError(error: AxiosError<ErrorData>): void {
   try {
      const status = error.response?.status;
      const method = error.config?.method?.toUpperCase() ?? '';
      const url = error.config?.url ?? '';
      const errorName = `[${status ?? 'NO_RESPONSE'} ${error.code ?? ''}] ${method} ${url}`.replace(/\s+/g, ' ').trim();

      Sentry.captureException(new Error(errorName), {
         extra: {
            request: {
               url,
               method: error.config?.method,
               params: error.config?.params,
               data: error.config?.data,
            },
            response: {
               code: error.code,
               message: error.message,
               status,
               data: error.response?.data,
            },
         },
      });
   } catch {
      // never let reporting break the request flow
   }
}

const responseSuccessInterceptor = (response: AxiosResponse) => response;

const responseErrorInterceptor = (error: AxiosError<ErrorData>) => {
   if (axios.isCancel(error) || error.message === 'Request aborted') {
      return Promise.reject(error);
   }

   const status = error.response?.status;

   if (status !== undefined && (status === 400 || status === 404 || status >= 500)) {
      captureSentryError(error);
   }

   return Promise.reject(error);
};

export { responseErrorInterceptor, responseSuccessInterceptor };

